/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PersonneHistoryGridDto
 */
export interface PersonneHistoryGridDto {
    /**
     * 
     * @type {number}
     * @memberof PersonneHistoryGridDto
     */
    idpersonneHistory?: number;
    /**
     * 
     * @type {number}
     * @memberof PersonneHistoryGridDto
     */
    iduser?: number;
    /**
     * 
     * @type {number}
     * @memberof PersonneHistoryGridDto
     */
    idpersonne?: number;
    /**
     * 
     * @type {string}
     * @memberof PersonneHistoryGridDto
     */
    action?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonneHistoryGridDto
     */
    actionType?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof PersonneHistoryGridDto
     */
    actionDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof PersonneHistoryGridDto
     */
    userName?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PersonneHistoryGridDto
     */
    ifapmeSide?: Array<string> | null;
}

/**
 * Check if a given object implements the PersonneHistoryGridDto interface.
 */
export function instanceOfPersonneHistoryGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PersonneHistoryGridDtoFromJSON(json: any): PersonneHistoryGridDto {
    return PersonneHistoryGridDtoFromJSONTyped(json, false);
}

export function PersonneHistoryGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonneHistoryGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idpersonneHistory': !exists(json, 'idpersonneHistory') ? undefined : json['idpersonneHistory'],
        'iduser': !exists(json, 'iduser') ? undefined : json['iduser'],
        'idpersonne': !exists(json, 'idpersonne') ? undefined : json['idpersonne'],
        'action': !exists(json, 'action') ? undefined : json['action'],
        'actionType': !exists(json, 'actionType') ? undefined : json['actionType'],
        'actionDate': !exists(json, 'actionDate') ? undefined : (new Date(json['actionDate'])),
        'userName': !exists(json, 'userName') ? undefined : json['userName'],
        'ifapmeSide': !exists(json, 'ifapmeSide') ? undefined : json['ifapmeSide'],
    };
}

export function PersonneHistoryGridDtoToJSON(value?: PersonneHistoryGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idpersonneHistory': value.idpersonneHistory,
        'iduser': value.iduser,
        'idpersonne': value.idpersonne,
        'action': value.action,
        'actionType': value.actionType,
        'actionDate': value.actionDate === undefined ? undefined : (value.actionDate.toISOString()),
        'userName': value.userName,
        'ifapmeSide': value.ifapmeSide,
    };
}

